module.exports = __webpack_public_path__ + "static/media/kasri.a46884f0.png";